import {
  AccountCircleOutlined,
  CalendarViewDayOutlined,
  Crop32Outlined,
  HMobiledataOutlined,
  HorizontalRuleOutlined,
  HtmlOutlined,
  ImageOutlined,
  LibraryAddOutlined,
  NotesOutlined,
  SmartButtonOutlined,
  ViewColumnOutlined,
  ViewListOutlined,
} from '@mui/icons-material';
import { type TBlock } from '@wp-block-builder/package';
import ProgressBarOutlined from '@wp-react/components/icons/ProgressBarOutlined';

export default function getBlockIconComponent(type: TBlock['type']) {
  switch (type) {
    case 'Avatar':
      return AccountCircleOutlined;
    case 'Button':
      return SmartButtonOutlined;
    case 'ColumnsSection':
      return ViewColumnOutlined;
    case 'Container':
      return LibraryAddOutlined;
    case 'ContainerYield':
      return CalendarViewDayOutlined;
    case 'Divider':
      return HorizontalRuleOutlined;
    case 'Heading':
      return HMobiledataOutlined;
    case 'Html':
      return HtmlOutlined;
    case 'Image':
      return ImageOutlined;
    case 'LoopContainer':
      return ViewListOutlined;
    case 'ProgressBar':
      return ProgressBarOutlined;
    case 'Spacer':
      return Crop32Outlined;
    case 'Text':
      return NotesOutlined;
  }
}
